export default "__VITE_ASSET__CLeUGtwr__"